import React from 'react';
import { formatDescriptionLine } from './string-normalization';

export const parseContent = (content: string) => {
    const elements = content.split(/(<img[^>]*>)/);
    return elements.map((element, index) => {
        if (element.startsWith('<img')) {
            const srcMatch = /src="([^"]*)"/.exec(element);
            const src =  srcMatch?.[1];
            return React.createElement('img', { key: `${index}-${src}`, src });
        } else {
            return formatDescriptionLine(element);
        }
    });
};

export const getServiceLevelDisplay = (serviceLevel?: string): 'STANDARD' | 'ADVANCED' | 'PREMIUM' => {
    switch(serviceLevel?.toLowerCase()) {
        case 'bronze':
            return 'STANDARD';
        case 'gold':
            return 'PREMIUM';
        case 'silver':
            return 'ADVANCED';
        default:
            return 'STANDARD';
    }
};